module.exports = __webpack_public_path__ + "static/icons/icon-copy-text--black-7c63ee28c7c8fa9910339ed935487cd5.svg";